import { useObserver } from 'mobx-react-lite';
import React, { FC } from 'react';
import { useFrontFacingDisplayContext } from '../../stores/FrontFacingDisplayStore';
import ViewStateContainer from '../Core/ViewStateContainer/ViewStateContainer';
import FrontFacingDisPlay from './FrontFacingDisplay';

const FrontFacingDisplayPage: FC<{}> = () => {
  const ffdStore = useFrontFacingDisplayContext();

  return useObserver(() => (
    <ViewStateContainer
      state={ffdStore.viewState}
      onReload={() => ffdStore.reload()}
    >
      <FrontFacingDisPlay ffd={ffdStore.frontFacingDisplay} />
    </ViewStateContainer>
  ));
};

export default FrontFacingDisplayPage;
